// Browsers step a focused <input type="number"> when the mouse wheel is used
// over it, which silently changes quantities in forms and modals. While a
// number input has focus, swallow wheel events on it so the value stays put.
// The listener is only attached to the focused input (not the whole document)
// so normal page scrolling stays passive everywhere else.
const preventWheel = (event) => event.preventDefault()

const isNumberInput = (el) => el instanceof HTMLInputElement && el.type === 'number'

export default function disableNumberWheel () {
  document.addEventListener('focusin', (event) => {
    if (isNumberInput(event.target)) {
      event.target.addEventListener('wheel', preventWheel, { passive: false })
    }
  })

  document.addEventListener('focusout', (event) => {
    if (isNumberInput(event.target)) {
      event.target.removeEventListener('wheel', preventWheel)
    }
  })
}
